export const ADD_LABEL = 'ADD_LABEL';
export const ADD_LABEL_SUCCESS = 'ADD_LABEL_SUCCESS';
export const ADD_LABEL_FAILED = 'ADD_LABEL_FAILED';

export const GET_LABELS = 'GET_LABELS';
export const GET_LABELS_SUCCESS = 'GET_LABELS_SUCCESS';
export const GET_LABELS_FAILED = 'GET_LABELS_FAILED';

export const EDIT_LABEL = 'EDIT_LABEL';
export const EDIT_LABEL_SUCCESS = 'EDIT_LABEL_SUCCESS';
export const EDIT_LABEL_FAILED = 'EDIT_LABEL_FAILED';

export const DELETE_LABEL = 'DELETE_LABEL';
export const DELETE_LABEL_SUCCESS = 'DELETE_LABEL_SUCCESS';
export const DELETE_LABEL_FAILED = 'DELETE_LABEL_FAILED';

export const ASSIGN_LABELS = 'ASSIGN_LABELS';
export const ASSIGN_LABELS_SUCCESS = 'ASSIGN_LABELS_SUCCESS';
export const ASSIGN_LABELS_FAILED = 'ASSIGN_LABELS_FAILED';

export const REMOVE_LABEL = 'REMOVE_LABEL';
export const REMOVE_LABEL_SUCCESS = 'REMOVE_LABEL_SUCCESS';
export const REMOVE_LABEL_FAILED = 'REMOVE_LABEL_FAILED';